<template>
  <div>
    <template
      v-if="
        this.$store.state.nameTheme == 'MR' || this.$store.state.theme == 'mr'
      "
    >
      <svg
        width="45"
        height="45"
        viewBox="0 0 34 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1215_27843)">
          <path
            d="M17.4485 0.0119093C16.8306 -0.0145433 16.3762 0.0119093 16.1285 0.0119093C13.438 0.0551953 0 2.49845 0 16.6963C0 27.0777 10.0839 37.4471 14.9311 42.4346C15.388 42.906 15.8063 43.3316 16.1646 43.7116C16.3377 43.8943 16.583 44.0002 16.8306 44.0002C17.0783 44.0002 17.3283 43.8967 17.4966 43.7116C17.8549 43.3316 18.2708 42.906 18.7301 42.4346C23.5773 37.4519 33.6612 27.0825 33.6612 16.7011C33.666 2.49845 20.329 0.0672192 17.6313 0.0239332L17.4485 0.0119093Z"
            fill="#96154A"
          />
          <rect
            x="20.976"
            y="12.203"
            width="3.20234"
            height="1.9214"
            fill="white"
          />
          <rect
            x="20.9759"
            y="16.0458"
            width="3.20234"
            height="1.9214"
            fill="white"
          />
          <rect
            x="20.9759"
            y="19.8886"
            width="3.20234"
            height="1.9214"
            fill="white"
          />
          <rect
            x="15.2106"
            y="12.203"
            width="3.20234"
            height="1.9214"
            fill="white"
          />
          <rect
            x="15.2107"
            y="16.0458"
            width="3.20234"
            height="1.9214"
            fill="white"
          />
          <rect
            x="15.2107"
            y="19.8886"
            width="3.20234"
            height="1.9214"
            fill="white"
          />
          <rect
            x="9.44632"
            y="12.203"
            width="3.20234"
            height="1.9214"
            fill="white"
          />
          <rect
            x="9.44629"
            y="16.0458"
            width="3.20234"
            height="1.9214"
            fill="white"
          />
          <rect
            x="9.44629"
            y="19.8886"
            width="3.20234"
            height="1.9214"
            fill="white"
          />
          <rect
            x="5.60382"
            y="10.2815"
            width="1.9214"
            height="13.4498"
            fill="white"
          />
          <rect
            x="26.0996"
            y="10.2815"
            width="1.9214"
            height="13.4498"
            fill="white"
          />
          <rect
            x="4.32318"
            y="23.7314"
            width="24.9786"
            height="1.92143"
            fill="white"
          />
          <rect
            x="12.7613"
            y="8.36005"
            width="2.02526"
            height="1.9214"
            fill="white"
          />
          <rect
            x="10.7369"
            y="8.36005"
            width="2.02526"
            height="1.9214"
            fill="white"
          />
          <rect
            x="8.71118"
            y="8.36005"
            width="2.02526"
            height="1.9214"
            fill="white"
          />
          <rect
            x="6.68567"
            y="8.36005"
            width="2.02526"
            height="1.9214"
            fill="white"
          />
          <rect
            x="6.68567"
            y="8.36005"
            width="2.02526"
            height="1.9214"
            fill="white"
          />
          <rect
            x="14.7868"
            y="8.36005"
            width="2.02526"
            height="1.9214"
            fill="white"
          />
          <rect
            x="16.8123"
            y="8.36005"
            width="2.02526"
            height="1.9214"
            fill="white"
          />
          <rect
            x="18.8379"
            y="8.36005"
            width="2.02526"
            height="1.9214"
            fill="white"
          />
          <rect
            x="20.8631"
            y="8.36005"
            width="2.02526"
            height="1.9214"
            fill="white"
          />
          <rect
            x="22.8878"
            y="8.36005"
            width="2.02526"
            height="1.9214"
            fill="white"
          />
          <rect
            x="24.9133"
            y="8.36005"
            width="2.02526"
            height="1.9214"
            fill="white"
          />
          <rect
            x="4.99826"
            y="8.36005"
            width="2.02526"
            height="1.9214"
            fill="white"
          />
          <rect
            x="4.32312"
            y="8.36002"
            width="2.02526"
            height="1.9214"
            fill="white"
          />
          <rect
            x="25.9257"
            y="8.36005"
            width="2.02526"
            height="1.9214"
            fill="white"
          />
          <rect
            x="25.9257"
            y="8.36005"
            width="2.02526"
            height="1.9214"
            fill="white"
          />
          <rect
            x="27.2758"
            y="8.36005"
            width="2.02526"
            height="1.9214"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1215_27843">
            <rect width="33.6612" height="44" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </template>

    <template
      v-if="
        this.$store.state.nameTheme == 'inpost' ||
        this.$store.state.theme == 'inpost'
      "
    >
      <svg
        width="30"
        height="40"
        viewBox="0 0 140 183"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_73_798)">
          <path
            d="M72.57 0.0499958C70 -0.0600229 68.11 0.0499958 67.08 0.0499958C55.89 0.230026 0 10.3918 0 69.4418C0 112.619 41.94 155.746 62.1 176.49C64 178.45 65.74 180.221 67.23 181.801C67.95 182.561 68.97 183.001 70 183.001C71.03 183.001 72.07 182.571 72.77 181.801C74.26 180.221 75.99 178.45 77.9 176.49C98.06 155.766 140 112.639 140 69.4618C140.02 10.3917 84.55 0.280035 73.33 0.100004L72.57 0.0499958Z"
            fill="#FFCC05"
          />
          <path
            d="M0.0599976 72.1284C1.74144 114.442 42.3963 156.264 62.1532 176.61C64.0548 178.573 65.7963 180.345 67.2876 181.927C68.0082 182.688 69.0291 183.128 70.06 183.128C71.0909 183.128 72.1318 182.698 72.8324 181.927C74.3236 180.345 76.0551 178.573 77.9668 176.61C97.7337 156.285 138.399 114.462 140.06 72.1284H0.0599976Z"
            fill="#1D1D1D"
          />
          <path
            d="M58.005 120.598C54.8676 118.919 51.3661 118.041 47.8098 118.041C44.2536 118.041 40.7521 118.919 37.6147 120.598C40.7503 122.283 44.2525 123.165 47.8098 123.165C51.3672 123.165 54.8693 122.283 58.005 120.598Z"
            fill="#FFCC05"
          />
          <path
            d="M61.9826 104.628C60.0021 101.682 57.3294 99.2706 54.2 97.6056C51.0706 95.9406 47.5808 95.0734 44.0383 95.0805C46.0163 98.0286 48.6886 100.442 51.8185 102.107C54.9485 103.773 58.4395 104.639 61.9826 104.628Z"
            fill="#FFCC05"
          />
          <path
            d="M73.0801 92.3921C72.7349 88.873 71.5174 85.4964 69.5385 82.5699C67.5554 79.6196 64.8712 77.2108 61.728 75.5608C62.0734 79.0923 63.2904 82.482 65.269 85.4238C67.2476 88.3656 69.9256 90.7669 73.0612 92.411"
            fill="#FFCC05"
          />
          <path
            d="M61.9826 136.557C60.0021 139.503 57.3294 141.915 54.2 143.58C51.0706 145.245 47.5808 146.112 44.0383 146.105C46.0163 143.157 48.6886 140.743 51.8185 139.078C54.9485 137.413 58.4395 136.547 61.9826 136.557Z"
            fill="#FFCC05"
          />
          <path
            d="M73.0801 148.804C72.7426 152.343 71.5248 155.739 69.5385 158.683C67.553 161.634 64.8696 164.045 61.728 165.702C62.0642 162.161 63.277 158.761 65.2562 155.81C67.2354 152.86 69.9183 150.451 73.0612 148.804"
            fill="#FFCC05"
          />
          <path
            d="M75.5093 129.321C77.9145 129.082 80.2289 128.274 82.262 126.963C65.961 122.729 79.1831 97.8751 90.4786 92.8646C73.2048 94.2759 64.516 107.375 64.4594 120.456C64.4027 133.536 73.0821 146.891 90.5352 148.198C83.2489 144.098 77.8547 137.297 75.5093 129.255"
            fill="#FFCC05"
          />
          <path d="M100.68 43.78H87.3401V51.78H100.68V43.78Z" fill="#1D1D1D" />
          <path d="M100.68 59.79H87.3401V67.79H100.68V59.79Z" fill="#1D1D1D" />
          <path
            d="M76.6701 43.78H63.3301V51.78H76.6701V43.78Z"
            fill="#1D1D1D"
          />
          <path
            d="M76.6701 59.79H63.3301V67.79H76.6701V59.79Z"
            fill="#1D1D1D"
          />
          <path
            d="M52.6601 43.78H39.3201V51.78H52.6601V43.78Z"
            fill="#1D1D1D"
          />
          <path
            d="M52.6601 59.79H39.3201V67.79H52.6601V59.79Z"
            fill="#1D1D1D"
          />
          <path
            d="M122.02 27.77H70.0101H69.9901H17.9801V35.77H23.3201V72.22H31.3201V35.77H69.9901H70.0101H108.68V72.22H116.69V35.77H122.02V27.77Z"
            fill="#1D1D1D"
          />
        </g>
        <defs>
          <clipPath id="clip0_73_798">
            <rect width="140" height="183" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </template>
  </div>
</template>

<script>
export default {};
</script>
